/**
 * version-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import {
  validateAs,
  validateFor
} from "../../validation/decorators";
import { MessageTag } from "../message-tag";
import { IncomingMessage } from "./incoming-message";

/**
 * A client begins a conversion with a server by sending a {@link
 * VersionRequest} that includes its preferred protocol version.
 * The server responds with {@link VersionResponse}.
 * Its {@linkplain Message#json() JSON} comprises:
 *
 * <ul>
 *     <li>
 *         {@code "version"}: the {@linkplain #clientVersion()} client's
 *         preferred protocol version}.
 *     </li>
 * </ul>
 *
 * @author Todd L Smith &lt;tsmith@safetyweb.org&gt;
 */
@validateFor(MessageTag.RSP_VERSION)
export class VersionResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_VERSION;

  /**
   * true if compatibility has been positively determined, and false if it
   * remains undetermined.
   */
  @validateAs("boolean")
  public ok : boolean;

  /**
   * An array comprising the protocol versions supported by the server. Only
   * present if `ok` false.
   * TODO: validation for this
   */
  public supported : number[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/general/version-response.ts